export default {"src":"/_next/static/media/switch.19aa511a.svg","height":34,"width":34};